const SearchForm = require('../ui/search');
const CardService = require('../../services').Cards;
const CardResult = require('../ui/card-result').default;
const { objectMap } = require('../../lib/util/object-map');
const template = require('./cards-search.tpl').default;

module.exports = DomClass(template, function CardsSearch() {
	var _t = this;

	this.page_size = 10;

	this.search = function(query, after, keep_url) {
		this.searchform.item = query;
		this.searchform.search(query, after, keep_url);
	};

	this.searchform.getResults = function(query, after, keep_url) {
		after = after || '';

		if (!keep_url) {
			const search_url = '?cards/~/' + encodeURIComponent(query) + '/gt/' + after;
			history.pushState(search_url, search_url, search_url);
		}

		api_page_size = _t.page_size + 1;
		return CardService.getIndex(query, after, api_page_size).then(results => {
			let next;
			if (results.length > _t.page_size) {
				results.pop();
				next = '?cards/~/' + encodeURIComponent(query) + '/gt/' + encodeURIComponent(results[results.length - 1]);
			} else {
				next = '';
			}

			const items = objectMap(
				results,
				async cardName => {
					const card = await CardService.get(cardName);
					return new CardResult(card);
				}
			).data;

			return { items, next };
		});
	};

	// facilitates keyboard opening and navigation
	this.searchform.open = function(card) {
		card.open();
	};
});
